<div class="cv-dropdown-button btn-group cv-dropdown-button-component">
	<button #mainButton
		[disabled]="disabled"
		type="button"
		class="btn"
		[ngClass]="buttonClass"
		(click)="buttonClicked()">

		<ng-container *ngIf="!isImg">
			<i *ngIf="icon"
			 class="fa"
			 [ngClass]="icon"></i> {{label}}
		</ng-container>
		
		<ng-container *ngIf="isImg">
			<img [src]="label" class="img-fluid btn-img">
		</ng-container>
	</button>
	<div class="btn-group">
		<button #dropdownButton
			[disabled]="disabled"
			type="button"
			class="btn dropdown-toggle action-toggle"
			[ngClass]="buttonClass"
			(click)="toggleDropdown()">
		</button>

		<div #dropdownMenu
			class="dropdown-menu"
			[ngClass]="{'show': isOpen}">

			<span *ngFor="let item of items; let index = index">
				<div *ngIf="item.type === DROPDOWN_BUTTON_ITEM_TYPE.SEPARATOR" class="dropdown-divider"></div>
				<div *ngIf="item.type === DROPDOWN_BUTTON_ITEM_TYPE.LABEL" class="dropdown-header">
					{{item.label}}
				</div>
				<a *ngIf="item.type === DROPDOWN_BUTTON_ITEM_TYPE.OPTION"
					class="dropdown-item action-select"
					[ngClass]="buttonClass"
					(click)="selectSubOption(item, index)"
					href="javascript:void(0);">
					
					<ng-container *ngIf="!item.image">
						<i *ngIf="item.icon"
							class="sub-item fa"
							[ngClass]="item.icon">
						</i>
						<span class="item-value">{{item.label || ('Option ' + index)}}</span>
					</ng-container>
					
					<ng-container *ngIf="item.image">
						<img [src]="item.image" class="img-fluid btn-img">
						<span class="cv-test item-value">{{item.image}}</span>
					</ng-container>
				</a>
			</span>
		</div>
	</div>
</div>
